theme.footerSection = (function () {

  /* ── Utilidades slide propias ── */
  function slideDown(el) {
    el.style.display = 'block';
    var h = el.scrollHeight;
    el.style.overflow = 'hidden';
    el.style.height = '0';
    el.style.transition = 'height 0.3s ease';
    requestAnimationFrame(function () {
      el.style.height = h + 'px';
    });
    el.addEventListener('transitionend', function handler() {
      el.style.height = '';
      el.style.overflow = '';
      el.style.transition = '';
      el.removeEventListener('transitionend', handler);
    });
  }

  function slideUp(el) {
    el.style.overflow = 'hidden';
    el.style.height = el.scrollHeight + 'px';
    el.style.transition = 'height 0.3s ease';
    requestAnimationFrame(function () {
      el.style.height = '0';
    });
    el.addEventListener('transitionend', function handler() {
      el.style.display = 'none';
      el.style.height = '';
      el.style.overflow = '';
      el.style.transition = '';
      el.removeEventListener('transitionend', handler);
    });
  }

  function getSiblings(el) {
    return Array.from(el.parentElement.children).filter(function (child) {
      return child !== el;
    });
  }

  function footer() {
    /* ── Mobile navigation bar height ── */
    var mobileNavigateBar = document.querySelector('.mobile__navigation--bar');
    if (mobileNavigateBar) {
      document.documentElement.style.setProperty(
        '--mobile-navigation-bar-height',
        mobileNavigateBar.clientHeight + 'px'
      );
      window.addEventListener('resize', function () {
        document.documentElement.style.setProperty(
          '--mobile-navigation-bar-height',
          mobileNavigateBar.clientHeight + 'px'
        );
      });
    }

    /* ── Footer accordion ── */
    var accordion = true;

    var footerWidgetAccordion = function () {
      accordion = false;
      document.querySelectorAll('.footer__widget_toggle').forEach(function (item) {
        item.addEventListener('click', function () {
          var footerWidget = this.closest('.footer__widget');
          var footerWidgetInner = footerWidget.querySelector('.footer__widget_inner');

          if (footerWidget.classList.contains('active')) {
            footerWidget.classList.remove('active');
            slideUp(footerWidgetInner);
          } else {
            footerWidget.classList.add('active');
            slideDown(footerWidgetInner);

            getSiblings(footerWidget).forEach(function (sibling) {
              var sibWidget = sibling.querySelector('.footer__widget');
              var sibInner = sibling.querySelector('.footer__widget_inner');
              if (sibWidget && sibInner) {
                sibWidget.classList.remove('active');
                slideUp(sibInner);
              }
            });
          }
        });
      });
    };

    if (accordion) {
      footerWidgetAccordion();
    }

    window.addEventListener('resize', function () {
      document.querySelectorAll('.footer__widget').forEach(function (item) {
        if (window.outerWidth >= 750) {
          item.classList.remove('active');
          var inner = item.querySelector('.footer__widget_inner');
          if (inner) inner.style.display = '';
        }
      });
      if (accordion) {
        footerWidgetAccordion();
      }
    });
  }

  return footer;
})();